import React from 'react';
import styles from './DensityBanner.module.css';

export type DensityTab = 'overview' | 'routes' | 'zipClusters';

interface DensityBannerProps {
  activeTab: DensityTab;
  onTabChange: (tab: DensityTab) => void;
}

export const DensityBanner: React.FC<DensityBannerProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className={styles.banner}>
      <div className={styles.bannerContent}>
        <h2 className={styles.bannerTitle}>Route Density Engine</h2>
        <p className={styles.bannerSubtitle}>Optimize route profitability and geographic efficiency</p>
      </div>
      <div className={styles.tabs}>
        <button
          className={`${styles.tab} ${activeTab === 'overview' ? styles.tabActive : ''}`}
          onClick={() => onTabChange('overview')}
        >
          Overview
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'routes' ? styles.tabActive : ''}`}
          onClick={() => onTabChange('routes')}
        >
          Routes
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'zipClusters' ? styles.tabActive : ''}`}
          onClick={() => onTabChange('zipClusters')}
        >
          ZIP Clusters
        </button>
      </div>
    </div>
  );
};
